import React, { useState, useEffect } from "react";
import { Link, Redirect, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Tabs from "../components/Tabs";
import imageHelper from "../assets/images/addroom-help.png";
import swal from "@sweetalert/with-react";
import AddRoomAlert from "../components/AddRoom";
import { getSelectedHotel, setSelectedHotel, setSelectedRoom } from "../actions/hotel";
import { useHotels } from "../graphql/useHotels";
import Loading from "../components/Loading";
import useAddRoom from "../hooks/useAddRoom";
import { markdown } from "utils/others";
import { setIdentityOrigin } from "reducers/reducerIdentity";

const AddRoom = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { project: paramProject } = useParams();
    const { search } = useLocation();

    const searchParams = new URLSearchParams(search);
    const paramRoom = searchParams ? searchParams.get("room") : null;
    const paramCode = searchParams ? searchParams.get("code") || searchParams.get("surname") : null;
    const paramOrigin = searchParams ? searchParams.get("origin") : null;

    const project = useSelector(getSelectedHotel);

    const [redirectTo, setRedirectTo] = useState("");
    const { loading: loadingHotels } = useHotels({ autoload: true });
    const { addRooms, loading: addingRoom } = useAddRoom({ project });

    const switchingProject = paramProject && project?.ref !== paramProject;

    if (switchingProject) {
        dispatch(setSelectedHotel(paramProject));
    }

    useEffect(() => {
        if (paramOrigin) {
            dispatch(setIdentityOrigin(paramOrigin));
        }
    }, [paramOrigin, dispatch]);

    const onRoomAdded = (number) => {
        return (success) => {
            if (success) {
                dispatch(setSelectedRoom(number));
                setRedirectTo("/site");
            }
        };
    };

    const onError = () => {
        return (e) => {
            console.error(e);
        };
    };

    const handleForm = async (data) => {
        const code = data?.code || data?.surname;
        addRooms([{ number: data.room, code: code, onError: data.onError }], { check: true, checkWiFi: true })
            .then(onRoomAdded(data.room))
            .catch(onError());
    };

    useEffect(() => {
        if (project?.mobilePath) {
            if (paramRoom && paramCode) {
                window.history.replaceState({}, "", window.location.pathname);
                addRooms([{ number: paramRoom, code: paramCode }], { check: true, checkWiFi: true })
                    .then(onRoomAdded(paramRoom))
                    .catch(onError());
            }
        }
    }, [project]);

    if (!switchingProject && !project) {
        return <Redirect push to="/site/list" />;
    }

    if (redirectTo) {
        return <Redirect to={redirectTo} />;
    }

    return (
        <>
            {switchingProject || loadingHotels ? (
                <Loading />
            ) : (
                <section className={"basic has-top" + (addingRoom ? "" : " has-tabs")}>
                    <Header
                        title={t("add room")}
                        backAction={
                            addingRoom
                                ? null
                                : () => {
                                    setRedirectTo("/site");
                                }
                        }
                    />
                    <section>
                        {addingRoom && (
                            <Loading />
                        )}
                        <div className=" shadow-xl p-8">
                            <p className=" w-full text-center font-bold">{markdown(t("add room info"))}</p>
                            <p className=" w-full text-center">
                                {markdown(t("contact-our-staff-more-information"))}
                            </p>
                            <AddRoomAlert onSuccess={handleForm}></AddRoomAlert>

                        </div>

                    </section>
                    {addingRoom ? null : <Tabs />}
                </section>
            )}
        </>
    );
};

export default AddRoom;
